import React from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";

interface LightBoxProps {
  isLightboxOpen: boolean;
  images: string[];
  closeLightbox: () => void;
  activeImageIndex: number;
  setActiveImageIndex: (index: number) => void;
}

const LightBox: React.FC<LightBoxProps> = ({
  isLightboxOpen,
  images,
  closeLightbox,
  activeImageIndex,
  setActiveImageIndex,
}) => {
  const showNext = () => {
    setActiveImageIndex((activeImageIndex + 1) % images.length);
  };

  const showPrev = () => {
    setActiveImageIndex((activeImageIndex - 1 + images.length) % images.length);
  };

  return (
    <>
      {isLightboxOpen && images.length > 0 && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 md:p-6">
          {/* Close button */}
          <button
            onClick={closeLightbox}
            className="
              fixed top-6 right-6 z-[100]
              w-10 h-10 flex items-center justify-center
              bg-black/60 rounded-full
              text-white
              hover:bg-black/80 transition
            "
          >
            <X className="w-6 h-6" />
          </button>

          {/* Image container */}
          <div className="relative w-full h-full max-w-7xl select-none flex flex-col items-center justify-center">
            <img
              src={images[activeImageIndex]}
              alt={`Flat image ${activeImageIndex + 1}`}
              className="
                max-h-full
                max-w-full
                w-auto h-auto
                rounded-2xl 
                object-contain
                block
              "
            />

            {/* Prev */}
            {images.length > 1 && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  showPrev();
                }}
                className="
                  absolute left-4 top-1/2 -translate-y-1/2 z-10
                  w-12 h-12 flex items-center justify-center
                  bg-black/60 rounded-full
                  text-white
                  hover:bg-black/80 transition
                "
              >
                <ChevronLeft className="w-8 h-8" />
              </button>
            )}

            {/* Next */}
            {images.length > 1 && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  showNext();
                }}
                className="
                  absolute right-4 top-1/2 -translate-y-1/2 z-10
                  w-12 h-12 flex items-center justify-center
                  bg-black/60 rounded-full
                  text-white
                  hover:bg-black/80 transition
                "
              >
                <ChevronRight className="w-8 h-8" />
              </button>
            )}

            {/* Counter */}
            <div className="mt-4 text-center text-sm text-white/80">
              {activeImageIndex + 1} / {images.length}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LightBox;
